import { LanguageModel } from "./generalLoginType"



export interface LanguageState {
    model:LanguageModel,
}

export const LanguageInitialState : LanguageState = {
    model:{
        language:"de-DE",
    },
}


export function deepCopyTableThingyState(toCopy:LanguageState):LanguageState{
    return {
        model:{
            ...toCopy.model,
        },
    }
    
}